import CircleRoundedIcon from "@mui/icons-material/CircleRounded";

export const circle = (props) => {
  return <CircleRoundedIcon {...props} />;
};
